export default __webpack_public_path__ + "static/Best-Countries-for-Shopaholics-Milan-Italy-be8102b860d4ebc7b2aa3480073f2e95.jpg";